import { Skeleton } from "@/components/shared/Skeleton";

export function MissingElementWarningsSkeleton() {
  return (
    <div className="w-72 border-l border-slate-200 flex flex-col flex-1 overflow-hidden">
      {/* Header */}
      <div className="flex items-center gap-2 p-4 border-b border-slate-200">
        <Skeleton className="w-6 h-6 rounded-full flex-shrink-0" />
        <div className="flex-1 space-y-1">
          <Skeleton className="h-4 w-32" />
          <Skeleton className="h-3 w-40" />
        </div>
      </div>

      {/* Body */}
      <div className="flex-1 overflow-y-auto px-4 py-3 space-y-4">
        {/* Mobile warning */}
        <div className="p-3 border-l-4 border-slate-200 rounded flex gap-2">
          <Skeleton className="w-5 h-5 rounded flex-shrink-0" />
          <div className="flex-1 space-y-1">
            <Skeleton className="h-3 w-24" />
            <Skeleton className="h-3 w-44" />
          </div>
        </div>

        {/* Checklist rows */}
        <div className="space-y-2">
          {Array.from({ length: 4 }).map((_, i) => (
            <div key={`${i + 1}`} className="flex items-center gap-3 rounded-md p-2 bg-slate-50">
              <Skeleton className="w-5 h-5 rounded-full flex-shrink-0" />

              <div className="flex-1 space-y-1">
                <Skeleton className="h-3 w-28" />
                <Skeleton className="h-3 w-16" />
              </div>

              <Skeleton className="h-3 w-10" />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
